import type { DeepPartial } from '@luna/utils-ts';

import type { KycFeatureConfig } from '../type';

export const kyc: DeepPartial<KycFeatureConfig> = {
    oidcReady: true,
    handoverTargetClientId: 'urn:cz:csas:mep:proxyAppSso',
};
